import axios from "axios";
import { BASE_URL } from "./apiConfig";
import { getToken, getStoreId, getTenantId } from "./helper";
import { handle401Error } from "./refreshHandler";

export const API = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  const storeId = getStoreId();
  if (storeId) config.headers.common["X-STORE"] = storeId;
  const tenantId = getTenantId();
  if (tenantId) config.headers["X-TENANT"] = tenantId;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => handle401Error(error, API),
);
